import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=9ff8890a&scoped=true&"
import script from "./MainPanel.vue?vue&type=script&lang=js&"
export * from "./MainPanel.vue?vue&type=script&lang=js&"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=9ff8890a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff8890a",
  null
  
)

export default component.exports